export default __webpack_public_path__ + "static/media/rating.f0e8e34d.svg";